import React from 'react'
import { Box } from '@mui/material'

/**
 * RadialBackgroundContainer - Inner container with radial heritage gradient
 *
 * Design: Radial gradient from white/20% to transparent, blended with heritage blue background
 * Uses soft-light blend mode for the radial gradient effect
 */

export interface RadialBackgroundContainerProps {
  children: React.ReactNode
  className?: string
  onClick?: () => void
  /** Whether to use fixed h-20 height (default: true) */
  useFixedHeight?: boolean
}

export const RadialBackgroundContainer: React.FC<RadialBackgroundContainerProps> = ({
  children,
  className = '',
  onClick,
  useFixedHeight = true
}) => {
  const heightClass = useFixedHeight ? 'h-20' : ''

  return (
    <Box
      onClick={onClick}
      className={`flex-1 ${heightClass} p-4 items-center gap-4 rounded-[10px] border border-white/[0.04] shadow-[inset_0_1px_0_0_rgba(255,255,255,0.08)] ${className}`}
      sx={{
        background:
          'radial-gradient(50.19% 50.19%, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), rgba(46, 79, 95, 0.5)',
        backgroundBlendMode: 'soft-light, normal',
        cursor: onClick ? 'pointer' : 'default'
      }}
    >
      {children}
    </Box>
  )
}

export default RadialBackgroundContainer
